// extracted by mini-css-extract-plugin
module.exports = {"layerNavigator":"LayerSwitcher_layerNavigator__Wuvax","navigatorIcon":"LayerSwitcher_navigatorIcon__WfE62"};